var React = require('react');

function DocumentDollar12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 12V2.5L7.5 0H2V12H10ZM3.625 4.5C3.625 3.45041 4.30586 2.55983 5.25 2.24585V1H6.75V2.24585C7.69414 2.55983 8.375 3.45041 8.375 4.5H6.625C6.625 4.15482 6.34518 3.875 6 3.875C5.65482 3.875 5.375 4.15482 5.375 4.5C5.375 4.84518 5.65482 5.125 6 5.125C7.31168 5.125 8.375 6.18832 8.375 7.5C8.375 8.54959 7.69414 9.44017 6.75 9.75415V11H5.25V9.75415C4.30586 9.44017 3.625 8.54959 3.625 7.5H5.375C5.375 7.84518 5.65482 8.125 6 8.125C6.34518 8.125 6.625 7.84518 6.625 7.5C6.625 7.15482 6.34518 6.875 6 6.875C4.68832 6.875 3.625 5.81168 3.625 4.5Z","fill":"currentColor"}));
}

DocumentDollar12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = DocumentDollar12;

DocumentDollar12.default = DocumentDollar12;
